interface NavigateFunction {
  (page: string, state?: any): void;
}

// Define the interface for the History object
interface HistoryType {
  navigate: NavigateFunction | null;
  push: NavigateFunction;
}

export const AppHistory: HistoryType = {
  navigate: null,
  push: (page, ...rest) => {
    if (AppHistory.navigate) {
      AppHistory.navigate(page, ...rest);
    }
  },
};
